<template>
  <div class="tkBusyCursorButton">
    <tk-image
      v-if="loading"
      class="tkBusyCursorButton_loadingImg"
      image-path="https://www.tabikobo.com/tour/media/tabi_sp_files/img/bx_loader.gif"
      alt="Loading image"
    />
    <tk-button
      v-else
      class="tkBusyCursorButton_btn"
      @click="pushed"
    >
      {{ displayedLabel }}
    </tk-button>
  </div>
</template>

<script>
import TkButton from '../../../atoms/TkButton/TkButton'
import TkImage from '../../../atoms/TkImage/TkImage'

export default {
  name: 'TkBusyCursorButton',
  components: {
    TkButton,
    TkImage,
  },
  props: {
    displayedLabel: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    pushed() {
      this.$emit('pushed')
    },
  },
}
</script>

<style lang="scss">
.tkBusyCursorButton_loadingImg {
  width: 32px;
}
.tkBusyCursorButton_btn {
  background: #63666a;
  color: #fff;
  padding: 5px 10px  !important;
  font-size: 12px !important;
  line-height: 1.5  !important;
  border-radius: 3px  !important;
  border-color: #ccc  !important;
  font-family: 游ゴシック,YuGothic,ヒラギノ角ゴ ProN W3,Hiragino Kaku Gothic ProN,メイリオ,Meiryo,sans-serif;
  cursor: pointer  !important;
}
</style>
